module.exports = __webpack_public_path__ + "static/media/phone.286b1979.svg";